module.exports = __webpack_public_path__ + "static/media/bg.cfd9489b.png";